import { css } from 'styled-components';
import token from 'styled-token';
import { checkboxStateMixin } from '../checkboxStateMixin';
import { RadioMixin } from './RadioMixin';
var zsgCSS = token('Radio.borderWidth', function (borderWidth) {
  return css(["input&,input&:hover,input&:active,input&:focus{&:checked{border-width:", "px;}}"], borderWidth);
});

/** @class CheckboxMixin */
/** @method */
export var CheckboxMixin = function CheckboxMixin(props) {
  return css(["", " ", " ", " &:checked{", "}&&:indeterminate{", "}"], RadioMixin(props), zsgCSS(props), checkboxStateMixin()(props), checkboxStateMixin('checked')(props), checkboxStateMixin('indeterminate')(props));
};